import "./DownloadIcon.css";

export default function DownloadIcon({ onClick, title, size = "small", colour }) {
  return (
    <button
      type="button"
      className={`download-icon-btn${size === "large" ? " download-icon-btn--large" : ""}`}
      onClick={onClick}
      title={title}
      aria-label={title || "Download"}
      style={colour ? { "--download-icon-colour": colour } : undefined}
    >
      <span className="download-icon-halo" />
      <svg
        className="download-icon-arrow"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 3v12" />
        <path d="M7 10l5 5 5-5" />
        <path d="M5 21h14" />
      </svg>
    </button>
  );
}
